import { ModuleList } from '../../../shared/analytics/module-list';
import { pagesConfig } from '../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import GroupTemplatesGrid from './group-templates-grid';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import { Outlet } from 'react-router-dom';

export default function GroupTemplatesPage() {
  const isFormPage = useRouteMatch([
    `${pagesConfig.groupTemplates.link}/${pagesConfig.createGroupTemplate.link}`,
    `${pagesConfig.groupTemplates.link}/${pagesConfig.editGroupTemplate.link}`,
  ]);

  if (isFormPage) {
    return <Outlet />;
  }

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.directory.name },
        { label: pagesConfig.groupTemplates.name },
      ]}
      bookmarkKey={pagesConfig.groupTemplates.value}
    >
      <GroupTemplatesGrid />
    </SimpleBreadcrumbsPage>
  );
}
